export const API_PATH_ApiTrafficStudiesVehiclesCounterDataSearchGet = '/services/traffic-studies/apiTrafficStudiesVehiclesCounterDataSearchGet';
